export default __webpack_public_path__ + "static/media/servicios.1806a06d.png";